<template>
  <div class="approval-report-wrapper flex">
    <d-search :searchData="searchData" @searchEvent="search" @exportEvent="exportList" @resetEvent="reset">
      <time-search ref="timeSearch" :param.sync="searchData.params" :options="$map.getter('BPMtimeTags')"  :default-select="7"></time-search>
    </d-search>

    <div class="statistics-block">
      <div v-for="(item,index) in statisticsList" :key="index" class="statistic-item" :style="{background:staticItemBg[index]}">
        <label>{{item.label}}</label>
        <div class="fontsize20 bold">{{item.value}}</div>
      </div>
    </div>
    <div class="inline-flex contentBox">
      <d-table :tableData="tableData" :columnData="columnData" class="contentTable" @viewEvent="seeDetail">
        <el-table-column slot="approveTimeConsuming" label="流程耗时" prop="duration">
          <template slot-scope="{row}">
            <span :class="{'colorRed':row.containTimeOutNode}">{{row.approveTimeConsuming}}</span>
          </template>
        </el-table-column>
      </d-table>
    </div>
    <d-paging :pager="pager" @change="searchList"></d-paging>
  </div>

</template>

<script>

import DSearch from "@/components/d-search";
import TimeSearch from "@/pages/statement/approval-report/components/time-search";
import DTable from "@/components/d-table";
import {onDownload} from "@/utils/utils";
import DPaging from "@/components/d-paging";
import {searchPeopleCondition} from "@/pages/statement/approval-report/components/peopleMixin";
import {Arrays} from "@/utils/Arrays";

export default {
  name: "approval-statistics-list",
  components: {DPaging, DTable, TimeSearch, DSearch},
  mixins: [searchPeopleCondition],
  data(){
    return {
      typeLists:[],
      searchData:{
        searchItem:[
          {label:'审批类型',value:'keyList',type:'commonSelect',options:this.typeLists,multiple:true,filterable:true},
          {label:'申请人',value:'user',type:'linkageSelect',options:this.peopleList,filterable:true,optionProps:{
              label: "name",value: "value",children:"children",emitPath:false
            }
          },
          {label:'流程编号',value:'processNumber',type:'commonInput'}
        ],
        params:{
          keyList:'',
          user:'',
          processNumber:'',
          startTime:'',
          endTime:''
        },
        searchBtn:{
          queryBtn:true,
          resetBtn:true,
          exportBtn:true
        }
      },
      staticItemBg:[
        'linear-gradient(to right bottom,#5b69fe,#979cff)',
        'linear-gradient(to right bottom,#2eb2ff,#91e0fa)',
        'linear-gradient(to right bottom,#e56f79,#f0a99d)',
        'linear-gradient(to right bottom,#ef8d48,#fcd3a6)',
        'linear-gradient(to right bottom,#62d28a,#bfe794)',
        'linear-gradient(to right bottom,#d06fe5,#fadffd)'
      ],
      statisticsList:[],
      peopleList:[],
      tableData:[],
      columnData:[
        {label:'流程编号',prop:'processNumber'},
        {label:'审批类型',prop:'activitiName'},
        {label:'提交部门',prop:'deptName'},
        {label:'提交人',prop:'applicationUser'},
        {label:'流程完成时间',prop:'overTime'},
        {label:'流程耗时',prop:'approveTimeConsuming',slot:true},
        {label:'状态',prop:'status'},
        {label:'操作',prop:'operate',type:{
            viewBtn:true
          }
        },
      ],
      pager: {
        count: 0,
        page: 1,
        rows: 10,
      },
      viewType:''
    }
  },
  mounted(){
    this.getTypeList();
    this.getPeople();
    this.search();
  },
  methods:{
    // 获取审批类型
    getTypeList(){
      this.$api.dynamicForm.externalKey().then(({data}) => {
        this.typeLists = data.map(e => ({label:e.text,value:e.keyList}));
        this.searchData.searchItem.forEach(ele => {
          if (ele.value === 'keyList') {
            ele.options = this.typeLists
          }
        })
      })
    },

    getPeople(){
      this.$api.personnel.sysPeopleTree().then((res) => {
        this.peopleList = new Arrays().map([res.data], (item) => {
          item.children && !item.children.length && item.userId && delete item.children;
          item.value = (item.mobile || 'd-'+item.deptId)+'' ;
          item.name = item.name;
          return item;
        })
        this.searchData.searchItem.forEach(ele => {
          if (ele.value === 'user') {
            ele.options = this.peopleList
          }
        })
      });
    },

    _getParams(){
      return {
        keyList:[this.searchData.params.keyList].join(','),
        user:this.searchData.params.user,
        processNumber:this.searchData.params.processNumber,
        endDate:this.searchData.params.endTime,
        startDate:this.searchData.params.startTime,
        pageNum: this.pager.page,
        pageSize: this.pager.rows
      }
    },
    search(){
      if(!this.$refs.timeSearch.validate()) return ;
      this.pager.page = 1;
      this.pager.rows = 10;
      this.getOrderData();
      this.searchList();
    },
    // 查询工单汇总数据
    getOrderData(){
      this.$api.mentapi.aprOrders(this._getParams()).then(({data})=>{
        this.statisticsList = [
          {label:'总审批单',value:data.totalNum},
          {label:'处理中',value:data.pendingNum},
          {label:'通过',value:data.passNum},
          {label:'驳回',value:data.rejectNum},
          {label:'终止',value:data.suspendNum},
          {label:'平均耗时',value:data.avgTimeConsuming},
        ];
      })
    },

    // 查询列表
    searchList(){
      this.$api.mentapi.aprStatisticList(this._getParams()).then(({data})=>{
        this.tableData = data.records;
        this.pager.count = data.total;
      })
    },

    // 导出
    exportList(){
      this.$api.mentapi.aprStatisticExport({...this._getParams(),pageSize:10000,pageNum:1}).then(({headers,data})=>{
        onDownload(headers,data)
      })
    },

    reset(){
      this.$refs.timeSearch.reset();
      this.search()
    },

    async seeDetail(row) {
      // 通过processId 查询ID
      const {data:{typeId,id}} = await this.$api.dynamicForm.getId(row.processId)
      this.$router.push({path:`/statement/approvalReport/statistic/detail/${typeId}/${id}`})
    },
  }
}
</script>

<style scoped lang="scss">
.approval-report-wrapper{
  display: flex;
  background: #fff;
  .statistics-block{
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    .statistic-item{
      margin: 10px 10px 0 0;
      padding: 16px 10px;
      display: inline-flex;
      border: 1px solid #eee;
      box-shadow: 0 0 5px #e4e4e4;
      border-radius: 10px;
      flex: 1;
      color: #fff;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      label{
        color: #fff;
      }
    }
  }
}
</style>